import React from 'react';
import { StyledFooter } from './styles';

const DrawerFooter = ({ children }: { children: React.ReactNode }) => (
  <StyledFooter>{children}</StyledFooter>
);

export { DrawerFooter };
